import PropTypes from "prop-types";
import React, { Component } from "react";
import { MenuItem, Select } from "@material-ui/core";
import { getMonths } from "../utils/constants";
import { DateTime } from "luxon";
import { Trans } from "@lingui/macro";

class SelectsDate extends Component {
  constructor(props) {
    super(props);
    let startDay = 1;
    const days = Array.from(Array(31), () => startDay++);
    const months = getMonths();
    this.state = {
      currentDay: "",
      currentMonth: "",
      currentYear: "",
      days: days,
      months: months
    };
    console.log(months);
  }

  updateDays = () => {
    const dob = DateTime.local(
      this.state.currentYear || DateTime.local().year,
      this.state.currentMonth || 1
    );
    const daysInMonth = dob.daysInMonth;
    if (this.state.days.length !== daysInMonth) {
      let startDay = 1;
      this.setState({ days: Array.from(Array(daysInMonth), () => startDay++) });

      if (this.state.currentDay > daysInMonth) {
        this.setState({ currentDay: 1 });
      }
    }
    const date = `${this.state.currentYear || DateTime.local().year}-${this
      .state.currentMonth || 1}-${this.state.currentDay || 1}`;
    this.props.getDate(date);
  };

  onDobChange = () => {
    return {
      day: selectedDay => {
        this.setState(
          { currentDay: selectedDay.target.value },
          this.updateDays
        );
      },
      month: selectedMonth => {
        this.setState(
          { currentMonth: selectedMonth.target.value },
          this.updateDays
        );
      },
      year: selectedYear => {
        this.setState(
          { currentYear: selectedYear.target.value },
          this.updateDays
        );
      }
    };
  };

  render() {
    let startYear = new Date().getFullYear();
    const years = Array.from(Array(2), () => startYear++);
    return (
      <React.Fragment>
        {this.props.label && (
          <label className="date-label">{this.props.label}</label>
        )}
        <div className="display-flex date-birthday wrap-input">
          <Select
            name="dob_day"
            value={this.state.currentDay}
            onChange={this.onDobChange().day}
            variant="outlined"
            displayEmpty
          >
            <MenuItem value="">
              <Trans id="W_STEP4_FORMULAIRE_JOUR" />
            </MenuItem>
            {this.state.days &&
              this.state.days.map(day => (
                <MenuItem key={`day-${day}`} value={day}>
                  {day}
                </MenuItem>
              ))}
          </Select>
          <Select
            name="dob_month"
            value={this.state.currentMonth}
            onChange={this.onDobChange().month}
            variant="outlined"
            displayEmpty
          >
            <MenuItem value="">
              <Trans id="W_STEP4_FORMULAIRE_MOIS" />
            </MenuItem>
            {this.state.months.map(month => (
              <MenuItem key={`month-${month.value}`} value={month.value}>
                {month.label}
              </MenuItem>
            ))}
          </Select>
          <Select
            name="dob_year"
            value={this.state.currentYear}
            onChange={this.onDobChange().year}
            variant="outlined"
            displayEmpty
          >
            <MenuItem value="">
              <Trans id="W_STEP4_FORMULAIRE_ANNEE" />
            </MenuItem>
            {years.map(year => (
              <MenuItem key={`year-${year}`} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </div>
      </React.Fragment>
    );
  }
}

SelectsDate.propTypes = {
  getDate: PropTypes.func,
  label: PropTypes.string
};

export default SelectsDate;
